import { render } from "./feather_icon.vue?vue&type=template&id=0a50d249"
import script from "./feather_icon.vue?vue&type=script&lang=js"
export * from "./feather_icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__